import { render, staticRenderFns } from "./ladder.vue?vue&type=template&id=bec0ced0&"
import script from "./ladder.vue?vue&type=script&lang=js&"
export * from "./ladder.vue?vue&type=script&lang=js&"
import style0 from "./ladder.vue?vue&type=style&index=0&id=bec0ced0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports